export const WHITE_LIST_ENDPOINT = 'https://xvkvojl7o2.execute-api.us-east-1.amazonaws.com/prod';
